import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { debounceTime } from 'rxjs';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import {
  IGetServico,
  IPatchServico
} from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import Swal from 'sweetalert2';

import { ITabelaServico } from './listagem-servico-model';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ParametrizacaoService } from 'src/app/services/ParametrizacaoService/parametrizacao.service';
import { IParametrizacao, IUpdateParametrizacao } from 'src/app/services/ParametrizacaoService/parametrizacao.model';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-listagem-servico',
  templateUrl: './listagem-servico.component.html',
  styleUrls: ['./listagem-servico.component.scss']
})
export class ListagemServicoComponent {
  isLoading: boolean = false;
  numeroPagina: number = 0;

  form = this._inicializarFormulario();
  tableData: ITabelaServico[] | Array<any> = [];
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;

  tableColumns = [
    { header: 'Código', key: 'codigo', type: 'text' },
    { header: 'Descrição', key: 'descricao', type: 'text' },
    { header: 'Vísivel no Agendamento', key: 'visivel', type: 'text' },
    { header: 'Caixa', key: 'caixa', type: 'text' },
    { header: 'Evento', key: 'evento', type: 'text' },
    {
      header: 'Suspender',
      key: 'ativo',
      type: 'checkbox',
      action: (item: any) => this.suspenderServico(item)
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarServico(item)
        },
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.editarServico(item)
        },
        {
          label: 'Excluir',
          img: 'assets/trashcan.png',
          action: (item: any) => this.excluirServico(item)
        }
      ]
    }
  ];

  multiplicadorSelecionado: string | null = null;
  valorAnteriorMultiplicador: string = '';
  multiplicadorOptions: IOptions[] = [
    {
      name: '1 vez o preço base',
      value: '1'
    },
    {
      name: '2 vezes o preço base',
      value: '2'
    },
    {
      name: '3 vezes o preço base',
      value: '3'
    },
    {
      name: '4 vezes o preço base',
      value: '4'
    },
    {
      name: '5 vezes o preço base',
      value: '5'
    },
  ];

  toleranciaSelecionado: string | null = null;
  valorAnteriorTolerancia: string = '';
  toleranciaOptions: IOptions[] = [
    {
      name: '1 minuto',
      value: '1'
    },
    {
      name: '5 minutos',
      value: '5'
    },
    {
      name: '10 minutos',
      value: '10'
    },
    {
      name: '15 minutos',
      value: '15'
    },
    {
      name: '20 minutos',
      value: '20'
    },
    {
      name: '30 minutos',
      value: '30'
    },
  ];

  horaCobrancaSelecionado: string | null = null;
  horaCobrancaValorAnterior: string = '';

  cobrarUnicoSelecionado: boolean = false;
  valorAnteriorCobrarUnico: boolean = false;

  prePtioSelecionado: string | null = null;
  valorAnteriorPrePtio: string = '';
  pkPrePtio: number = 0;

  get cobrarUnicoAtivo(): boolean {
    return this.cobrarUnicoSelecionado;
  }
  horaCobrancaOptions: IOptions[] = [
    {
      name: '1 hora',
      value: '1'
    },
    {
      name: '2 horas',
      value: '2'
    },
    {
      name: '5 horas',
      value: '5'
    },
    {
      name: '12 horas',
      value: '12'
    },
    {
      name: '24 horas',
      value: '24'
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private servicoService: ServicoService,
    private authService: AuthService,
    public swalAlert: SwalAlertService,
    public parametrizacaoService: ParametrizacaoService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_TIPO_SRVC: this.fb.control('', {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
    return form;
  }

  ngOnInit() {
    this.getServico();
    this.getParametrizacao(1, "toleranciaSelecionado", "valorAnteriorTolerancia");
    this.getParametrizacao(2, "multiplicadorSelecionado", "valorAnteriorMultiplicador");
    this.getParametrizacao(3, "horaCobrancaSelecionado", "horaCobrancaValorAnterior");
    this.getParametrizacaoBool(4, "cobrarUnicoSelecionado", "valorAnteriorCobrarUnico");
    this.getParametrizacaoByName('VL_PRE_PTIO_HORA', 'prePtioSelecionado', 'valorAnteriorPrePtio', 'pkPrePtio');
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getServico();
    });
  }

  navegarServico() {
    this.router.navigate(['parametrizacao/servico']);
  }

  mudarPagina(pagina: number) {
    this.numeroPagina = pagina;
    this.getServico(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '******';
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '******';
  }

  getServico(pageNumber?: number) {
    this.isLoading = true;

    const TX_TIPO_SRVC = String(this.form.controls.TX_TIPO_SRVC.value);

    this.authService.dadoLogin$.subscribe(({ idEmpresa }) => {
      this.servicoService.GetServico(undefined, 0).subscribe({
        next: (response: IGetServico[]) => {
          this.isLoading = false;
          this.tableData = response.map(item => {
            return {
              codigo: item.PK_SRVC ?? 0,
              descricao: String(item.TX_TIPO_SRVC),
              visivel: item.FL_AGND ? 'Sim' : 'Não',
              caixa: item.NU_CAIX_SRVC === 1 ? 'Pátio' : item.NU_CAIX_SRVC === 2 ? 'Serviços' : 'Não informado',
              evento: item.NU_EVNT_SRVC === 1 ? 'Entrada' : item.NU_EVNT_SRVC === 2 ? 'Laudo' : (item.NU_CAIX_SRVC === 1 ? '---' : 'Não informado'),
              empresa: item.FK_EPSA,
              ativo: item.NU_STTS_SRVC == 1 ? false : true,
              situacao: item.NU_STTS_SRVC,
              ...item
            };
          });
        },
        error: (_error: any) => {
          this.isLoading = false;
        }
      });
    });
  }

  editarServico(item: any) {
    const queryParams = {
      ...item,
      modoServico: 'Editar'
    };
    this.router.navigate(['cadastro/servico'], {
      queryParams: queryParams
    });
  }

  visualizarServico(item: any) {
    const queryParams = {
      ...item,
      modoServico: 'Visualizar'
    };
    this.router.navigate(['cadastro/servico'], {
      queryParams: queryParams
    });
  }

  suspenderServico(item: any) {
    let statusServico: number;

    statusServico = item.situacao == 1 ? 2 : 1;

    this.servicoService
      .PatchServico(item.codigo, { NU_STTS_SRVC: statusServico })
      .subscribe({
        next: () => {
          this.swalAlert.showAlert(
            'Sucesso!',
            `${
              statusServico == 1 ? 'Remoção da suspensão' : 'Suspensão'
            } realizada com sucesso.`,
            'success',
            true,
            false,
            undefined,
            () => {
              this.getServico();
            }
          );
        },
        error: () => {}
      });
  }

  excluirServico(item: any) {
    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja realizar a exclusão?',
      'warning',
      true,
      true,
      undefined,
      () => {
        const body: IPatchServico = {
          NU_STTS_SRVC: 0
        };

        this.servicoService.PatchServico(item.codigo, body).subscribe(
          response => {
            this.getServico();
          },
          error => {}
        );
      }
    );
  }

  editarParametrizacao(parametrizacao: IParametrizacao, callbackGetFn: () => void) {
    var UpdateParametrizacao: IUpdateParametrizacao = { Parametrizacao: parametrizacao}
    this.parametrizacaoService.UpdateParametrizacao(UpdateParametrizacao).subscribe(
      response => {
        callbackGetFn();
      },
      error => {}
    )
  }

  private getParametrizacao(
    id: number,
    targetProp: keyof this,
    targetPreviousProp?: keyof this
  ) {
    this.isLoading = true;

    this.parametrizacaoService.GetParametrizacaoById(id).subscribe({
      next: (response: IParametrizacao) => {
        (this as any)[targetProp] = response.VL_PRMT;

        if (targetPreviousProp) {
          (this as any)[targetPreviousProp] = response.VL_PRMT;
        }
      },
      error: () => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  private getParametrizacaoBool(id: number, targetProp: keyof this, targetPreviousProp?: keyof this) {
    this.parametrizacaoService.GetParametrizacaoById(id).subscribe({
      next: (response: IParametrizacao) => {
        const boolValue = response.VL_PRMT === 'True';
        (this as any)[targetProp] = boolValue;
        if (targetPreviousProp) {
          (this as any)[targetPreviousProp] = boolValue;
        }
      },
      error: () => {}
    });
  }

  private getParametrizacaoByName(name: string, targetProp: keyof this, targetPreviousProp: keyof this, targetPkProp: keyof this) {
    this.parametrizacaoService.GetParametrizacaoByName(name).subscribe({
      next: (response: IParametrizacao) => {
        (this as any)[targetProp] = response.VL_PRMT;
        (this as any)[targetPreviousProp] = response.VL_PRMT;
        (this as any)[targetPkProp] = response.PK_PRMT;
      }
    });
  }

  toggleCobrarUnico(value: boolean) {
    const novoValor = value ? 'True' : 'False';
    const confirmMessage = value ? 'Deseja ativar a cobrança única?' : 'Deseja desativar a cobrança única?';
    this.editarParametrizacaoHelper(
      { NM_PRMT: 'FL_COBR_UNIC', PK_PRMT: 4, VL_PRMT: novoValor },
      () => this.getParametrizacaoBool(4, 'cobrarUnicoSelecionado', 'valorAnteriorCobrarUnico'),
      confirmMessage,
      'cobrarUnicoSelecionado',
      'valorAnteriorCobrarUnico'
    );
  }

  editarHelperHelper(tipo: number, value: string) {
    switch (tipo) {
      case 1: // Tolerância
        this.editarParametrizacaoHelper(
          {
            NM_PRMT: "QT_MINU_TOLE",
            PK_PRMT: 1,
            VL_PRMT: value
          },
          () => this.getParametrizacao(1, "toleranciaSelecionado", "valorAnteriorTolerancia"),
          "Deseja alterar o valor da tolerância?",
          "toleranciaSelecionado",
          "valorAnteriorTolerancia"
        );
        break;

      case 2: // Multiplicador
        this.editarParametrizacaoHelper(
          {
            NM_PRMT: "NU_MULT_AGND",
            PK_PRMT: 2,
            VL_PRMT: value
          },
          () => this.getParametrizacao(2, "multiplicadorSelecionado", "valorAnteriorMultiplicador"),
          "Deseja alterar o valor do multiplicador?",
          "multiplicadorSelecionado",
          "valorAnteriorMultiplicador"
        );
        break;

      case 3: // Hora cobrança
        this.editarParametrizacaoHelper(
          {
            NM_PRMT: "QT_HORA_COBR",
            PK_PRMT: 3,
            VL_PRMT: value
          },
          () => this.getParametrizacao(3, "horaCobrancaSelecionado", "horaCobrancaValorAnterior"),
          "Deseja alterar o valor do tempo de cobrança?",
          "horaCobrancaSelecionado",
          "horaCobrancaValorAnterior"
        );
        break;

      case 5: // Pré-pátio
        this.editarParametrizacaoHelper(
          {
            NM_PRMT: "VL_PRE_PTIO_HORA",
            PK_PRMT: this.pkPrePtio,
            VL_PRMT: value
          },
          () => this.getParametrizacaoByName('VL_PRE_PTIO_HORA', 'prePtioSelecionado', 'valorAnteriorPrePtio', 'pkPrePtio'),
          "Deseja alterar o valor do pré-pátio?",
          "prePtioSelecionado",
          "valorAnteriorPrePtio"
        );
        break;

      default:
        console.warn("Tipo inválido no editarHelperHelper:", tipo);
    }
  }

  editarParametrizacaoHelper(
    parametrizacao: IParametrizacao,
    callback: () => void,
    confirmMessage: string,
    campoSelecionado: string,
    campoAnterior: string
  ) {
    if (!parametrizacao.VL_PRMT) return;

    Swal.fire({
      title: 'Atenção!',
      text: confirmMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "red",
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.editarParametrizacao(parametrizacao, callback);
        (this as any)[campoAnterior] = parametrizacao.VL_PRMT;
      } else {
        (this as any)[campoSelecionado] = (this as any)[campoAnterior];
      }
    });
  }
}
